var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorks4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 608,
    viewBox: "0 0 456 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1217_9744",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 456,
    height: 608
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 608,
    rx: 40,
    fill: "#ECFFFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1217_9744)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 608,
    fill: "#ECFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3863 358.098C83.3863 425.668 142.38 456.736 168.797 456.736C266.694 456.736 330.539 358.098 330.539 269.51C330.539 214.315 295.438 168.417 228.545 168.417C183.611 168.417 83.3535 229.996 83.3535 358.098H83.3863Z",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.604 283.75L358.756 350.764V216.769L242.604 149.788V283.75Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.756 350.764L375.504 340.975V206.98L358.756 216.769V350.764Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.604 149.789L358.756 216.769L375.504 206.981L259.351 140L242.604 149.789Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.542 287.253C309.922 285.256 302.58 280.837 296.091 274.911C289.405 268.822 284.194 261.62 280.359 253.435C276.361 244.956 274.132 236.085 274.099 224.168C274.067 219.65 275.378 212.874 278.655 206.588C279.966 204.1 281.474 201.874 283.145 199.942C274.23 201.907 267.479 207.308 262.923 215.984C259.613 222.269 258.302 229.046 258.368 233.564C258.4 245.48 260.629 254.385 264.628 262.831C268.462 271.016 273.673 278.218 280.359 284.307C286.849 290.2 294.19 294.652 302.81 296.649C310.676 298.45 318.345 298.024 325.621 294.128C328.898 292.36 331.651 290.134 333.946 287.482C328.931 288.628 323.786 288.432 318.542 287.253Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.959 258.575C342.271 244.302 337.158 231.665 328.44 220.469C322.639 213.005 315.592 207.014 306.972 203.02C301.368 200.434 295.469 198.862 289.274 199.124C287.111 199.222 285.079 199.517 283.113 199.975C281.441 201.939 279.933 204.133 278.622 206.621C275.312 212.907 274.001 219.683 274.067 224.201C274.1 236.117 276.328 245.022 280.327 253.468C284.194 261.653 289.372 268.855 296.059 274.944C302.548 280.837 309.889 285.289 318.509 287.286C323.753 288.497 328.899 288.661 333.913 287.515C336.076 285.027 337.879 282.212 339.288 279.069C342.238 272.554 343.319 265.647 342.959 258.575Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.748 263.715V223.611L326.115 256.48L298.748 263.715Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.881 273.027L315.672 279.804L351.199 375.005L362.408 368.228L351.396 337.88L358.934 349.96L370.176 343.184L326.881 273.027Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.672 279.804V349.829L329.175 342.692L338.942 375.004H351.199L341.531 343.576L358.934 349.96L315.672 279.804Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.48 171.592L363.379 183.606",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.608 187.961L392.58 195.851",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.979 170.282L381.406 184.228",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.086 239.489L392.188 227.475",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 212.971L398.809 210.713",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.753 458.999C258.139 458.999 270.611 446.541 270.611 431.173C270.611 415.804 258.139 403.346 242.753 403.346C227.367 403.346 214.895 415.804 214.895 431.173C214.895 446.541 227.367 458.999 242.753 458.999Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.055 411.464C224.071 410.449 225.186 409.566 226.333 408.747C218.401 419.616 219.352 434.937 229.151 444.726C238.984 454.547 254.29 455.463 265.171 447.541C264.351 448.687 263.466 449.767 262.45 450.815C251.569 461.684 233.937 461.684 223.055 450.815C212.174 439.946 212.174 422.333 223.055 411.464Z",
    fill: "#0F1936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.017 427.114H235.082V424.429C235.082 420.173 238.524 416.769 242.752 416.769H243.047C247.143 416.932 250.388 420.468 250.388 424.626V427.081H250.552C251.634 427.081 252.551 427.965 252.551 429.078V438.408C252.551 439.488 251.666 440.405 250.552 440.405H235.017C233.935 440.405 233.018 439.521 233.018 438.408V429.078C233.018 427.998 233.902 427.081 235.017 427.081V427.114ZM238.425 427.114V427.048H247.078V424.527C247.078 422.268 245.374 420.304 243.178 420.108H242.752C240.392 420.108 238.425 422.072 238.425 424.429V427.114Z",
    fill: "#0F1936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.722 262.59C137.107 262.59 149.58 250.132 149.58 234.763C149.58 219.395 137.107 206.937 121.722 206.937C106.336 206.937 93.8633 219.395 93.8633 234.763C93.8633 250.132 106.336 262.59 121.722 262.59Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.024 215.088C103.04 214.073 104.154 213.19 105.302 212.371C97.3702 223.24 98.3206 238.561 108.12 248.35C117.953 258.171 133.258 259.088 144.139 251.165C143.32 252.311 142.435 253.391 141.419 254.439C130.538 265.308 112.905 265.308 102.024 254.439C91.143 243.57 91.143 225.957 102.024 215.088Z",
    fill: "#0F1936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.954 230.737H114.02V228.052C114.02 223.796 117.461 220.392 121.689 220.392H121.984C126.081 220.555 129.326 224.091 129.326 228.249V230.704H129.489C130.571 230.704 131.489 231.588 131.489 232.701V242.031C131.489 243.111 130.604 244.028 129.489 244.028H113.954C112.873 244.028 111.955 243.144 111.955 242.031V232.701C111.955 231.621 112.84 230.704 113.954 230.704V230.737ZM117.363 230.737V230.671H126.015V228.15C126.015 225.892 124.311 223.927 122.115 223.731H121.689C119.329 223.731 117.363 225.695 117.363 228.052V230.737Z",
    fill: "#0F1936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8584 420.32C106.244 420.32 118.717 407.861 118.717 392.493C118.717 377.125 106.244 364.666 90.8584 364.666C75.4726 364.666 63 377.125 63 392.493C63 407.861 75.4726 420.32 90.8584 420.32Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1609 372.818C72.1769 371.803 73.2912 370.919 74.4383 370.101C66.5069 380.969 67.4573 396.291 77.2569 406.079C87.0893 415.9 102.395 416.817 113.276 408.895C112.457 410.04 111.572 411.121 110.556 412.168C99.6747 423.037 82.042 423.037 71.1609 412.168C60.2797 401.299 60.2797 383.687 71.1609 372.818Z",
    fill: "#0F1936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.091 388.434H83.1566V385.749C83.1566 381.494 86.5979 378.089 90.8258 378.089H91.1208C95.2176 378.253 98.4623 381.788 98.4623 385.946V388.401H98.6262C99.7077 388.401 100.625 389.285 100.625 390.398V399.728C100.625 400.809 99.7405 401.725 98.6262 401.725H83.091C82.0095 401.725 81.0918 400.841 81.0918 399.728V390.398C81.0918 389.318 81.9767 388.401 83.091 388.401V388.434ZM86.4996 388.434V388.368H95.1521V385.848C95.1521 383.589 93.4478 381.625 91.2519 381.428H90.8258C88.4661 381.428 86.4996 383.392 86.4996 385.749V388.434Z",
    fill: "#0F1936"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks4);
export default __webpack_public_path__ + "static/media/howItWorks4.343478092f75d3ff0fa603c0abbb6061.svg";
export { ForwardRef as ReactComponent };